import styled from "styled-components";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledTopicBlock = styled(FlexColumn)`
    width: 100%;
    height: 100%;
`;

export const StyledTopicHeaderContainer = styled(FlexRow)`
    padding: 16px 24px 12px 24px;
    justify-content: space-between;
    align-items: center;
`;

export const StyledTopicHeaderTitle = styled(FlexColumn)`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["500"])};
    font-size: 16px;
`;

export const StyledInsightBannerWrapper = styled.div`
    display: flex;
`;
